import {
  StyleSheet,
  View,
  Alert,
  Image,
  TouchableOpacity,
  Platform,
  BackHandler,
  Dimensions,
  Linking,
} from "react-native";
import { useState, useEffect, useCallback, useContext } from "react";
import {
  InputBox,
  IconButton,
  WebPageView,
  context,
} from "../accessories/accessories.js";
import CustomText from "../accessories/CustomText.js";
import {
  handleAPI,
  FormatPhoneLogin,
  validateEmail,
  log,
  handleOpenURL,
  handleTrackGA4Events,
  handleGetStoredCredential,
  handleSetStoredCredential,
  generateFingerprint,
  handleCreateNewSession,
  handleGetActiveLoan,
} from "../accessories/CommonFunctions.js";
import AntDesign from "react-native-vector-icons/AntDesign";
import FontAwesome from "react-native-vector-icons/FontAwesome";
import MaterialIcons from "react-native-vector-icons/MaterialIcons";
import XMLParser from "react-xml-parser";
import Checkbox from "expo-checkbox";
import * as SplashScreen from "expo-splash-screen";
import AsyncStorage from "@react-native-async-storage/async-storage";
import ScrollContainer from "../accessories/ScrollContainer.js";
import { REDIRECT_URL } from "@env";
import { web, ios, android } from "../accessories/Platform";
import { DMCImage } from "../accessories/accessories";
// import ArrowSpinner from "../accessories/ArrowSpinner.js";
import * as LocalAuthentication from "expo-local-authentication";
import ArrowSpinner from "../accessories/ArrowSpinner.js";
import useKeyboardHeight from "../accessories/KeyboardHeight.js";

export default function Login(props) {
  //---------- State Variable declarartion part ----------//
  const { contextDetails, setContextDetails } = useContext(context); //Get value from context
  const { navigation, from = "", performAction = null, loginType = "" } = props;

  const [logInDetails, setLoginDetails] = useState({});
  const [emialSentTo, setEmailSentTo] = useState(null);
  const [currentPage, setCurrentPage] = useState(null); //emailOnly
  const [isPasswordSecure, setIsPasswordSecure] = useState(true);
  const [isTerminated, setIsTerminated] = useState(false);
  const [isRemember, setIsRemember] = useState(false);
  const [appIsReady, setAppIsReady] = useState(false);
  const [hideSecureEmail, setHideSecureEmail] = useState(false);
  const [passwordMisMatch, setPasswordMisMatch] = useState("");
  const [deviceId, setDeviceId] = useState(null);
  const [processingStatus, setProcessingStatus] = useState(null);
  const [accesscodeWarningMsg, setAccesscodeWarningMsg] = useState(null);
  const [headerText, setHeaderText] = useState(
    `~~~Let's get started by entering a cell phone number or email address.`
  );

  const [credentials, setCredentials] = useState({
    userName: "",
    password: "",
    AccessCode: "",
    formatedUserName: "",
  });
  const [errorMessage, setErrorMessage] = useState({
    text: "",
    color: "red",
  });
  const [newPassword, setNewPassword] = useState({
    password: "",
    confirmPassword: "",
  });
  const [newIsPasswordSecure, setNewIsPasswordSecure] = useState({
    password: true,
    confirmPassword: true,
  });
  const [newPasswordMessage, setNewPasswordMessage] = useState({
    passwordMsg: "",
    confirmPasswordMsg: "",
  });
  const [webPageURL, setWebPageURL] = useState(
    // "../../../BorrowerApplication/Presentation/Webforms/DirectDefault.aspx?Skip=1&SessionId={66C11203-4FED-4F93-9137-9D98BD6970A1}"
    null
  );
  const [biometricDetails, setBiometricDetails] = useState({
    WebloginId: props?.route?.params?.WebLoginId || null,
    UserName: props?.route?.params?.UserName || null,
  });
  const [complianceMsg, setComplianceMsg] = useState(false);
  const CompMsg = `Message and data rates may apply\nMessage Frequency Varies\nReply “HELP” for help, Reply “STOP” to cancel.`;
  const [complianceURL, setcomplianceURL] = useState(null);
  //--------------------------------------------//

  //---------- Function declarartion part ----------//
  const handleEmailSentTo = (value) => {
    //Showing (Sent) messange under emial & cellphone
    setEmailSentTo(value);
    //Hide (Sent) messange under emial & cellphone after 2000ms
    setTimeout(() => {
      setEmailSentTo(null);
    }, 3000);
  };
  const updateCredential = (event) => {
    //Handling field value change
    let { name, value, isFormat } = event,
      obj = { [name]: value };
    // if (name === "userName" && value !== "") {
    //   value = value
    //     .replaceAll("-", "")
    //     .replaceAll("(", "")
    //     .replaceAll(")", "")
    //     .replaceAll(" ", "");
    // }
    if (isFormat)
      obj = { [name]: value, formatedUserName: FormatPhoneLogin(value) };
    else if (name === "userName")
      obj = { [name]: value, formatedUserName: value };
    setCredentials({ ...credentials, ...obj });
  };

  const handleClearState = () => {
    //resetting the screen after 1000ms
    setTimeout(() => {
      setProcessingStatus(null);
      setIsPasswordSecure(true);
      setCredentials({
        userName: "",
        password: "",
        AccessCode: "",
      });
      setBiometricDetails({
        WebloginId: biometricDetails?.WebloginId || null,
        UserName: biometricDetails?.UserName || null,
      });
      setErrorMessage({ text: "", color: "red" });
      setLoginDetails({});
      setIsRemember(false);
      setIsTerminated(false);
      setHideSecureEmail(false);
      setCurrentPage("emailOnly");
      setHeaderText(
        `~~~Let's get started by entering a cell phone number or email address.`
      );
    }, 0);
  };
  const handleUserNameValidation = () => {
    //Validating the email and cellphone here
    try {
      let UserName = credentials["userName"]
        .replaceAll("-", "")
        .replaceAll("(", "")
        .replaceAll(")", "")
        .replaceAll(" ", "");
      if (
        UserName === "" &&
        headerText.indexOf(`Let's create an account`) !== -1
      ) {
        setErrorMessage({ text: "" });
        return true;
      } else if (Number(UserName) > 0 && UserName.length !== 10) {
        setErrorMessage({ text: "Please enter a valid phone number." });
        return true;
      } else if (!validateEmail(UserName) && UserName.length !== 10) {
        setErrorMessage({
          text: "Please enter a valid email address or Cell Phone number.",
        });
        return true;
      }
    } catch (error) {
      console.error("Error from handleUserNameValidation ====> ", error);
    }
  };
  const handleNextClick = (flag) => {
    // console.log(logInDetails);
    // return;
    try {
      //---------- if re-entering same login id - will return here. ----------//
      let Emailoutside =
        logInDetails["Emailoutside"] || logInDetails["EmailOutside"];
      updateCredential({
        name: "formatedUserName",
        value: credentials["userName"],
        isFormat: true,
      });
      if (
        Emailoutside?.toString().toLocaleLowerCase() ===
          credentials["userName"]?.toString().toLocaleLowerCase() ||
        logInDetails["CellPhone"]?.toString().toLocaleLowerCase() ===
          credentials["userName"]?.toString().toLocaleLowerCase()
      ) {
        return false;
      }
      //------------------------------------------------//
      setLoginDetails({}); //Clear details if exist

      //---------- Validating username ----------//

      if (handleUserNameValidation()) return false;
      if (flag) return false;
      setComplianceMsg(false);
      setProcessingStatus("Next");
      //------------------------------------------------//
      //---------- Checking the login exist or not ----------//
      handleAPI({
        name: "GetUserNameExists",
        params: { userName: credentials["userName"] },
      }).then((response) => {
        response = JSON.parse(response)["Table"][0];

        if (parseInt(response["UserExists"]) === 1) {
          //Login exist - proceed next step
          // console.log("response", response);
          // setHeaderText(
          //   `~~~Welcome back ${response["UserDisplayName"]}. Please select a login option below.`
          // );
          setHeaderText(`~~~CustomHeader~~~${response["UserDisplayName"]}`);
          if (parseInt(response["AccountTerminated"]) === 1) {
            setCurrentPage("loginOption");
            setHeaderText("~~~Select your login method");
            setLoginDetails({ ...response });
          } else handleGetDeviceId(response);
        } else if (parseInt(response["UserExists"]) === 0) {
          //login not exist - entering signup process
          navigate("Signup", {
            userName: credentials["userName"],
            deviceId: deviceId,
          });
          handleClearState(); //resetting the screen
        }
      });
      //------------------------------------------------//
    } catch (error) {
      setProcessingStatus(null);
      log("Error from handleNextClick ====> ", error);
    }
  };
  const handleGetDeviceId = (logDetails) => {
    let userName = logDetails["EmailOutside"] || logDetails["Emailoutside"];
    //---------- Checking the device id stored for the lognin ----------//

    try {
      handleAPI({
        name: "GetDeviceFingerPrintWeb",
        params: { UserName: userName, DeviceId: deviceId },
      }).then((response) => {
        try {
          response = response.split("~");
          let obj = {
            deviceIdExist: Number(response[0]) || 0,
            saveCredential: response[1] || 0,
          };
          logDetails = { ...logDetails, ...obj };
        } catch (error) {
          log("Error from ====> GetDeviceFingerPrintWeb", error);
        }
        handleCreateSessionWebLogin(logDetails);
      });
    } catch (error) {
      log("Error from handleGetDeviceId ====> ", error);
    }
    //------------------------------------------------//
  };
  const handleCreateSessionWebLogin = (logDetails) => {
    try {
      //---------- Creating new seesion for the lognin ----------//
      let { WebLoginId } = logDetails;
      handleAPI({
        name: "CreateSessionWrapper",
        params: { WebLoginId: WebLoginId },
      }).then((response) => {
        response = response.split("~");

        let res = { SessionId: response[0], loginName: response[1] };
        logDetails = { ...logDetails, ...res };
        if (logDetails["isForgotPassword"]) {
          //For forgot password flow
          logDetails = { ...logInDetails, ...logDetails };
          handleGetNextStepWeb(logDetails);
        } else {
          //General flow for to login
          handleCheckPasscodeExpired(logDetails);
        }
      });
    } catch (error) {
      log("Error from handleCreateSessionWebLogin ====> ", error);
    }
    //------------------------------------------------//
  };
  const handleOpenPage = (page) => {
    let URL = "";

    if (page == 1) {
      URL = `https://www.directmortgage.com/terms-of-use/`;
    }
    if (page == 2) {
      URL = `https://www.directmortgage.com/privacy-policy/`;
    }

    setcomplianceURL(URL);
    setWebPageURL(URL);
  };
  const handleGetNextStepWeb = async (logDetails) => {
    try {
      //---------- Get which page to enter based on user type ----------//
      let { SessionId, UserType } = logDetails;
      handleAPI({
        name: "GetNextStepWeb",
        params: { SessionId: SessionId, username: "", IP: "::1" },
      }).then((response) => {
        response = JSON.parse(response)["Table"][0];

        let URL = response["Column1"];
        if (URL != "" && URL != null && URL != undefined) {
          URL = `${URL}&Skip=1`;
          // if (UserType === "C") {
          // }
          URL = `BorrowerWelcome`;
          let obj = { URL: URL };
          logDetails = { ...logDetails, ...obj };
          logDetails = { ...logInDetails, ...logDetails };
          if (UserType === "E") {
            handleCheckIsSignUpdoneWeb(logDetails);
            return false;
          }

          setLoginDetails(logDetails); //Storing login details in state
        }
      });
    } catch (error) {
      log("Error from handleGetNextStepWeb ====> ", error);
    }
    //------------------------------------------------//
  };
  const handleCheckIsSignUpdoneWeb = async (logDetails) => {
    //---------- Checking signup process is completed or still pending  ----------//
    try {
      let { SessionId, URL, WebLoginId } = logDetails;
      await handleAPI({
        name: "CheckIsSignUpdoneWeb",
        params: { SessionId: SessionId },
      }).then((response) => {
        if (response !== "{}") {
          response = JSON.parse(response)["Table"][0];
          let {
            IsSignUpComplete,
            ApprovalStatus,
            ApprovalTaskExists,
            CertDone,
            EmpNum,
            CompNum,
            logintype,
          } = response;
          let SignUpURL = "";
          SignUpURL =
            Number(IsSignUpComplete) === 0 || Number(IsSignUpComplete) === 2
              ? `../../../BorrowerApplication/Presentation/Webforms/SignUpWizard.aspx?WID=${WebLoginId}&SessionId=${SessionId}&EmpNum=${EmpNum}&CompNum=${CompNum}&FromLanding=0&FromProfile=&PType=${logintype}`
              : Number(IsSignUpComplete) === -3 &&
                Number(ApprovalStatus) === 3 &&
                Number(CertDone) === -1
              ? `../../../BorrowerApplication/Presentation/Webforms/SignUpWizard.aspx?WID=${WebLoginId}&SessionId=${SessionId}&EmpNum=${EmpNum}&CompNum=${CompNum}&FromLanding=0&FromProfile=&PType=${logintype}`
              : Number(IsSignUpComplete) === -3
              ? `../../../BorrowerApplication/Presentation/Webforms/SignUpWizard.aspx?WID=${WebLoginId}&SessionId=${SessionId}&EmpNum=${EmpNum}&CompNum=${CompNum}&FromLanding=0&FromProfile=&PType=${logintype}`
              : Number(ApprovalStatus) === 4 && Number(ApprovalTaskExists) === 0
              ? `../../../BorrowerApplication/Presentation/Webforms/NewBrokerApproval.aspx?SessionId=${SessionId}&EmpNum=${EmpNum}&CompNum=${CompNum}`
              : "";

          if (SignUpURL) URL = SignUpURL;
        }
        logDetails = { ...logDetails, URL: URL };
        setLoginDetails(logDetails);
      });
    } catch (error) {
      log("Error from handleCheckIsSignUpdoneWeb ====> ", error);
    }
    //------------------------------------------------//
  };
  const handleCheckPasscodeExpired = (logDetails) => {
    try {
      //---------- Checking Password is expired or not for the lognin ----------//
      let { WebLoginId, SessionId } = logDetails;
      handleAPI({
        name: "CheckPasscodeExpired",
        params: {
          WebLoginId: WebLoginId,
          SessionId: SessionId,
        },
      }).then((response) => {
        response = JSON.parse(response)["Table"][0];
        logDetails = { ...logDetails, ...response };
        //---------- Password is expired and not a terminated login - Sending access code to user ----------//
        if (
          parseInt(response["PasscodeExpired"]) === 1 &&
          parseInt(logDetails["AccountTerminated"]) !== 1
        ) {
          let msg = `${
            logDetails["UserDisplayName"]
          }!${"\n"}It looks like your passcode has expired. Please validate to renew your passcode.`;
          handleAccessCodeLogin(1, logDetails, msg);
        }
        //--------------------------------------------//
        //Manual login flow
        else if (logDetails["AutoRedirect"] === undefined) {
          setCurrentPage("loginOption");
          // setHeaderText("~~~Select your login method");
          if (!currentPage === "enterAccessCode") {
            logDetails = { ...logDetails, isEnterAccessCode: false };
          }
        }
        //Auto redirecting flow
        else if (logDetails["AutoRedirect"]) {
          handleLogin(undefined, logDetails);
          return false;
        }
        handleGetNextStepWeb(logDetails);
      });
    } catch (error) {
      log("Error from handleCheckPasscodeExpired ====> ", error);
    }
  };
  const handleLogin = async (flag, logDetails) => {
    //---------- If any actice session is found for the user Showing Procees & Wait option ----------//
    if (parseInt(logDetails["MultiLogin"]) === 1 && flag === undefined) {
      setCurrentPage("multiLogin");
      let { Emailoutside, EmailOutside, UserDisplayName } = logDetails;
      setHeaderText(
        `~~~${
          Emailoutside || EmailOutside || UserDisplayName || ""
        }!${"\n"}It looks like you're currently logged in on another device. Would you like to proceed?`
      );
      logDetails = { ...logDetails, AutoRedirectCheck: true };
      logDetails = { ...logDetails, ...logInDetails };
      setLoginDetails(logDetails);
      return false;
    }
    //--------------------------------------------//
    //---------- If User clicked Proceed option - it will close all active session ----------//
    if (currentPage === "setPassword&Login") {
      setProcessingStatus("loginNow");
    } else setProcessingStatus("validating");

    if (flag === 1) {
      setProcessingStatus("proceeding");
      handleCloseOtherSession(logDetails);
    }
    //--------------------------------------------//
    let emailId =
      logDetails["EmailOutside"] || logDetails["Emailoutside"] || "";
    setContextDetails((prevContextDetails) => {
      return { ...prevContextDetails, Email: emailId };
    });
    if (isRemember) {
      handleSetStoredCredential(1, {
        ...logDetails,
        ...logInDetails,
        DeviceId: deviceId,
      }); //Storing details for auto re-direct
      handleLogAutoGAEventPasscode(); //Storing login log - auto re-direct
      handleAPI({
        name: "SaveDeviceFingerPrintWeb",
        params: {
          UserName: logDetails["EmailOutside"] || logDetails["Emailoutside"],
          DeviceId: deviceId,
          SaveResp: 1,
          WebLoginId: logDetails["WebLoginId"],
        },
      }).then((response) => {});
    } else {
      handleSetStoredCredential(2); //Clearing details of auto re-direct
      handleLogGAEventPasscode(); //Storing login log - Manual
    }
    //Navigating to mobile application
    let { SessionId, UserDisplayName, loginName } = logDetails,
      userName = UserDisplayName || loginName || "";

    if (logDetails["URL"] === "BorrowerWelcome") {
      let { startNewLoan } = props?.route?.params || "";
      if (loginType === "secureDoc") {
        handleSecureDocLogin(logDetails);
      } else {
        let { activeLoanCount = 1, activeLoanId = -999 } =
          (await handleGetActiveLoan(SessionId)) || {};

        if (startNewLoan || activeLoanCount == 1) {
          setContextDetails((prevContextDetails) => {
            return {
              ...prevContextDetails,
              ...{ loanId: activeLoanId },
            };
          });
          navigate("Home", {
            userName,
            SessionId,
            loanId: activeLoanId,
          });
        } else {
          SessionId = !SessionId
            ? await handleCreateNewSession(logDetails["WebLoginId"])
            : SessionId;
          navigate("DashBoard", {
            userName,
            SessionId: SessionId,
          });
        }
      }
    } else {
      //replacing the session with new session
      let url_ = logDetails["URL"].split("?");
      let page = url_[0],
        queryString = url_[1];
      queryString = queryString.split("&");
      queryString = queryString
        .filter((item) => item.toLowerCase().indexOf("sessionid") === -1)
        .join("&");
      let url = `${page}?${queryString}&SessionId=${logDetails["SessionId"]}`;
      Platform.OS === "web"
        ? handleOpenURL(url) //Opening default browser with url
        : setWebPageURL(url);
    }
    loginType !== "secureDoc" && handleClearState(); //Resetting the screen
  };
  const handleCloseOtherSession = async (logDetails) => {
    await handleAPI({
      name: "CloseOtherSession",
      params: {
        WebLoginId: logDetails["WebLoginId"],
        SessionId: logDetails["SessionId"],
      },
    }).then((response) => {
      log("CloseOtherSession", response);
    });
  };
  const handleSecureDocLogin = async (logDetails) => {
    setErrorMessage({
      color: "#999",
      text: (
        <View style={{ flexDirection: "row", paddingLeft: 10 }}>
          <View style={{ height: 25 }}>
            <ArrowSpinner size={15} />
          </View>
          <CustomText>
            {"  "}
            Processing...Please wait...
          </CustomText>
        </View>
      ),
      italic: false,
    });

    let { SessionId, UserDisplayName, loginName } = logDetails,
      userName = UserDisplayName || loginName || "";

    let { activeLoanCount = 1, activeLoanId = 0 } =
      (await handleGetActiveLoan(SessionId)) || {};

    if (activeLoanCount == 1) {
      handleSelectLoan(activeLoanId, SessionId, userName);
    } else {
      navigate("DashBoard", {
        userName,
        SessionId,
      });
      handleClearState();
    }
  };
  const keyboardHeight = ios ? useKeyboardHeight() || 30 : 0;

  const handleSelectLoan = async (loanId, SessionId, userName) => {
    if (loanId == 0) {
      setErrorMessage({
        ...{
          color: "#999",
          text: (
            <View style={{ flexDirection: "row", paddingLeft: 10 }}>
              <View style={{ height: 25 }}>
                <ArrowSpinner size={15} />
              </View>
              <CustomText>
                {"  "}
                Loan Creation is in progress. Please wait...
              </CustomText>
            </View>
          ),
          italic: false,
        },
      });

      await handleAPI({
        name: "CreateLoanOnly",
        params: { sessionid: SessionId, empid: 1, EventId: 15 },
      })
        .then((response) => {
          loanId = JSON.parse(response);
          if (loanId != 0) {
            try {
              handleAPI({
                name: "AssociateLoanId_GA",
                params: {
                  SessionId,
                  LoanId: loanId,
                  LoginMethod: "UploadDocs",
                },
              })
                .then((response) => {
                  log("response", response);
                })
                .catch((e) => log("Error from AssociateLoanId_GA ====>", e));
            } catch (error) {}
          }
        })
        .catch((error) => log("Error from CreateLoanOnly ====> ", error));
    }

    navigate("Home", {
      userName,
      SessionId,
      loanId,
      GoToNav: 9,
    });
    handleClearState();
  };
  const handleLoginClick = async (flag) => {
    //Login with password and Accesscode
    //---------- Access Code entering flow ----------//
    try {
      if (currentPage === "enterAccessCode") {
        setErrorMessage({ text: "" });
        if (
          parseInt(credentials["AccessCode"]) ===
          parseInt(logInDetails["AccessCode"])
        ) {
          setProcessingStatus("validating");
          setLoginDetails({
            ...logInDetails,
            MaxPasscodeIncorrectLogin: 0,
          });
          if (
            Number(logInDetails["UsingSecpwd"]) === 0 &&
            Number(logInDetails["deviceIdExist"]) === 0
          ) {
            handleAPI({
              name: "SaveDeviceFingerPrintWebOnly",
              params: {
                Email:
                  logInDetails["EmailOutside"] || logInDetails["Emailoutside"],
                DeviceId: deviceId,
              },
            }).then((response) => {});
          }
          if (logInDetails["isForgotPassword"]) {
            //Showing Password set screen
            setHeaderText("~~~Set your password.");
            setCurrentPage("setPassword&Login");
            return false;
          }
          //---------- resetting password expired flag ----------//
          handleAPI({
            name: "UpdatePasscode",
            params: {
              refId: logInDetails["WebLoginId"],
            },
          }).then((response) => {});
          //--------------------------------------------//
          //---------- If cell phone is not exist in the login then showing option to add ----------//

          if (
            Object.keys(biometricDetails).length == 0 &&
            !logInDetails["isShowedBioMetricOption"]
          ) {
            if (await isFaceIdAvailable()) {
              setCurrentPage("bioMetricOption");
              setHeaderText(
                `~~~Optional. Do you want to Enable ${
                  ios ? "Face" : "Touch"
                } ID for Login.`
              );

              setLoginDetails({
                ...logInDetails,
                isShowedBioMetricOption: true,
              });
              return false;
            }
          }
          if (
            (logInDetails["CellPhone"] === undefined ||
              logInDetails["CellPhone"] === null ||
              logInDetails["CellPhone"] === "") &&
            flag !== -1
          ) {
            setCurrentPage("addCellPhone");
            setHeaderText(
              "~~~Optional. Add a Cell Phone Number to your account."
            );
            setLoginDetails(logInDetails);
            return false;
          }

          if (hideSecureEmail && flag !== -1) {
            handleAPI({
              name: "SavePhoneToAccount",
              params: {
                WebLoginId: logInDetails["WebLoginId"],
                Phone: logInDetails["CellPhone"],
              },
            }).then((response) => {
              handleLoginClick(-1);
            });
            return false;
          }
          //--------------------------------------------//

          handleLogin(flag, logInDetails); //General login process
        }
        //Handling entering invalid access code
        else {
          setProcessingStatus(null);
          setErrorMessage({ text: "Invalid Access Code." });
          let MaxPasscodeIncorrectLogin =
            parseInt(logInDetails["MaxPasscodeIncorrectLogin"] || 0) + 1;
          setLoginDetails({
            ...logInDetails,
            MaxPasscodeIncorrectLogin: MaxPasscodeIncorrectLogin,
          });
          handleLogFailedLoginEvent("Invalid Access Code.");
          if (MaxPasscodeIncorrectLogin === 5) {
            setHeaderText(
              `2nd Notice. ~~~This Login attempt has been blocked. The maximum login attempts have been exceeded. We have ${
                credentials["userName"].indexOf("@") === -1 ? "Text" : "Emailed"
              } you an access code. Enter it below.`
            );
            handleLogFailedLoginEvent(
              `This Login attempt has been blocked. The maximum login attempts have been exceeded. We have ${
                credentials["userName"].indexOf("@") === -1 ? "Text" : "Emailed"
              } you an access code. Enter it below.`
            );
          }
          //Reached max limit then terminating the user
          if (MaxPasscodeIncorrectLogin > 10) {
            handleAPI({
              name: "TerminateUserAccount",
              params: {
                WebLoginId: logInDetails["WebLoginId"],
              },
            }).then((response) => {
              setIsTerminated(true);
              setHeaderText(
                "~~~This account is terminated. Contact your administrator or MakeMeAware@directcorp.com for assistance."
              );
            });
          }
        }
      }
      //Multiple active session
      else if (currentPage === "multiLogin" && flag === 1) {
        setErrorMessage({ text: "" });
        setProcessingStatus("proceeding");
        handleLogin(flag, logInDetails);
      }
      //Enter password flow
      else {
        if (handleUserNameValidation()) {
          if (credentials["userName"] === "")
            setErrorMessage({ text: "Invalid Username" });
          return false;
        }
        if (credentials["password"] === "") {
          setErrorMessage({ text: "Invalid Password" });
          return false;
        }
        setProcessingStatus("validating");
        //Validating the credention is correct or not
        handleAPI({
          name: "ValidateLoginWithEmailorPhone",
          params: {
            UserName: credentials["userName"],
            Password: credentials["password"],
            SessionId: logInDetails["SessionId"],
          },
        }).then((response) => {
          try {
            response = JSON.parse(response)["Table"][0]["Column1"].toString();
            response = new XMLParser().parseFromString(response)["children"][0][
              "attributes"
            ];

            response["SessionId"] = logInDetails["SessionId"];
            response["MultiLogin"] = response["MultiLoginModel"];
            response["WebLoginId"] = logInDetails["WebLoginId"];
            response = { ...logInDetails, ...response };
            setLoginDetails(response);
            let { UserId } = response;
            //Invalid credentials
            if (UserId == 0) {
              setProcessingStatus(null);
              setErrorMessage({ text: "Invalid Username or Password." });
              handleLogFailedLoginEvent("Invalid Username or Password");

              // let MaxPasscodeIncorrectLogin =
              //   parseInt(logInDetails["MaxPasscodeIncorrectLogin"] || 0) + 1;
              // setLoginDetails({
              //   ...response,
              //   ...{
              //     MaxPasscodeIncorrectLogin: MaxPasscodeIncorrectLogin,
              //   },
              // });

              return false;
            }
            //Terminated User
            else if (UserId == -99) {
              setHeaderText(
                "~~~This account is terminated. Contact your administrator or MakeMeAware@directcorp.com for assistance."
              );
              handleLogFailedLoginEvent("This account is terminated.");
              setIsTerminated(true);
              setProcessingStatus(null);
              return false;
            }
            //Blocked User
            else if (UserId == -98) {
              handleLogFailedLoginEvent("This user account has been blocked");
              if (credentials["userName"].indexOf("@") !== -1)
                handleAccessCodeLogin(1);
              else handleAccessCodeLogin(2);
              // setErrorMessage({
              //   text: "This account is terminated. Contact your administrator or MakeMeAware@directcorp.com for assistance.",
              //   color: "#999",
              // });
              setErrorMessage({
                text: "",
              });
              setLoginDetails({
                ...response,
                AccountLocked: 1,
              });
              setProcessingStatus(null);
              return false;
            }
            //Missing Manditory Info.
            else if (UserId == -97) {
              handleLogFailedLoginEvent(
                "This user login is missing the required account information"
              );
              setErrorMessage({
                text: "This user login is missing the required account information. Please contact MakeMeAware@directcorp.com.",
                color: "#999",
              });
              setProcessingStatus(null);
              return false;
            }
            //Blocked User and sending Access code to user
            else if (UserId == -96) {
              handleLogFailedLoginEvent(
                "This Login attempt has been blocked. The maximum allowed login attempts has been exceeded"
              );
              // setErrorMessage({
              //   text: "This Login attempt has been blocked. The maximum allowed login attempts has been exceeded.",
              //   color: "#999",
              // });
              setErrorMessage({
                text: "",
              });
              let logDetails_ = { ...response, attemptExceed: 1 };
              setLoginDetails(logDetails_);
              if (credentials["userName"].indexOf("@") !== -1)
                handleAccessCodeLogin(1, logDetails_);
              else handleAccessCodeLogin(2, logDetails_);
              setProcessingStatus(null);
              return false;
            }
            //Blocked User
            else if (UserId == -95) {
              handleLogFailedLoginEvent("This user account has been blocked.");
              setErrorMessage({
                text: "This user account has been blocked. To Unblock this login, please contact MakeMeAware@directcorp.com.",
                color: "#999",
              });
              setProcessingStatus(null);
              return false;
            }
            if (
              Number(response["UsingSecpwd"]) === 0 &&
              Number(response["deviceIdExist"]) === 0 &&
              logInDetails["WebLoginId"] !== 427418 // Exception for iOS submission
            ) {
              let msg = `${
                response["UserDisplayName"]
              }!${"\n"}We recognize you, just not this specific device. We've ${
                credentials["userName"].indexOf("@") === -1 ? "Text" : "Emailed"
              } you an access code just to verify it's really you. Enter it below.`;

              if (credentials["userName"].indexOf("@") !== -1)
                handleAccessCodeLogin(1, response, msg);
              else handleAccessCodeLogin(2, response, msg);
              setProcessingStatus(null);
              return false;
            }

            //Valid credential - redirectng to corresponding page

            handleLogin(flag, response);
          } catch (e) {
            handleLogFailedLoginEvent("Database error");
            Alert.alert(
              "Database error. Please try again or contact MakeMeAware@directcorp.com for additional assistance."
            );
            log("Error from ValidateLoginWithEmailorPhone ====> ", e);
          }
        });
      }
    } catch (error) {
      log("Error from handleLoginClick ====> ", error);
    }
  };
  const handleLogGAEventPasscode = () => {
    //Storing login event details for Manual process
    try {
      handleAPI({
        name: "fnLogGAEvent_passcode",
        params: {
          UserWebloginId: logInDetails["WebLoginId"],
          device: "mobile",
          LO: 0,
          fromAction: "DWLogin",
          Prevpage: `${REDIRECT_URL}sitelogin`, //"Mobile Application",
        },
      }).then((response) => {});
    } catch (error) {
      log("Error from handleLogGAEventPasscode ====> ", error);
    }
  };
  const handleLogAutoGAEventPasscode = () => {
    //Storing login event details for Auto redirecting process
    try {
      handleAPI({
        name: "LogGAEvent",
        params: {
          UserWebloginId: logInDetails["WebLoginId"],
          device: "mobile",
          LO: 0,
          fromAction: "DWLogin",
          Prevpage: `${REDIRECT_URL}sitelogin`, //"Mobile Application",
        },
      }).then((response) => {});
    } catch (error) {
      log("Error from handleLogAutoGAEventPasscode ====> ", error);
    }
  };
  const handleLogFailedLoginEvent = async (Errmsg) => {
    //Storing login failed event details like invalid,Terminated login,etc...
    let strobj = {
      UserName: credentials["userName"],
      device: "mobile",
      Errmsg: Errmsg,
      IPAddress: deviceId || "",
      emailmethod: "DWLogin",
      LO: 0,
      PrevPage: `${REDIRECT_URL}sitelogin`, //"Mobile Application",
    };
    try {
      handleAPI({
        name: "LogFailedLoginEvent",
        params: strobj,
      }).then((response) => {});
    } catch (error) {
      log("Error from handleLogFailedLoginEvent ====> ", error);
    }
  };
  const handleCreateNewAccClick = () => {
    //Create New accout flow
    if (credentials["userName"] === "") {
      setHeaderText(
        "~~~Let's create an account. Begin by entering a cell phone number or email address."
      );
      setErrorMessage({ text: "" });
      return false;
    }
    //Checking the user already exist or not
    handleAPI({
      name: "GetUserNameExists",
      params: { userName: credentials["userName"] },
    }).then((response) => {
      response = JSON.parse(response)["Table"][0];
      response = { ...logInDetails, ...response };
      setLoginDetails(response);
      if (parseInt(response["UserExists"]) === 1) {
        //User exist - next screen to login
        setCurrentPage("emailOnly");

        setHeaderText(
          `~~~Let's get started by entering a cell phone number or email address.`
        );
      } else if (parseInt(response["UserExists"]) === 0) {
        //User not exist - Navigate to signup screen
        navigate("Signup", {
          userName: credentials["userName"],
          deviceId: deviceId,
        });
        handleClearState(); //Resetting the screen
      }
    });
  };
  const getSecureEmail = () => {
    //Showing Email like -> test.....@gmail.cm
    let Email = "";
    //Hide emial when cell phone adding optoion
    if (hideSecureEmail) return <></>;
    if (
      credentials["userName"] === "" ||
      credentials["userName"].indexOf("@") === -1
    ) {
      if (logInDetails["EmailOutside"] !== undefined)
        Email = logInDetails["EmailOutside"].split("@");
      else return <></>;
    } else Email = credentials["userName"].split("@");
    return (
      <>
        <CustomText
          onPress={() => {
            handleAccessCodeLogin(1);
          }}
          bold={true}
          style={[styles.footText, { alignSelf: "flex-start", fontSize: 13 }]}
        >
          Resend via email
        </CustomText>
        <CustomText
          bold={true}
          style={{ fontSize: 13, color: "#999", marginTop: 5 }}
        >
          {`${Email[0].slice(0, 2)}...${Email[1]}`}
        </CustomText>
        {emialSentTo === 1 && (
          <CustomText bold={true} style={{ color: "#0000ff", fontSize: 12 }}>
            Sent
          </CustomText>
        )}
      </>
    );
  };
  const getSecurePhone = () => {
    //Showing cellphone like -> xxx-xxx-8574
    let Phone = logInDetails["CellPhone"];
    if (Phone === undefined) {
      if (
        Number(credentials["userName"]) !== NaN &&
        credentials["userName"].indexOf("@") === -1
      ) {
        Phone = credentials["userName"];
      }
    } else Phone = Phone.slice(-4);
    return (
      <>
        {Phone === "" ? (
          <></>
        ) : (
          <>
            <CustomText
              onPress={() => {
                handleAccessCodeLogin(2);
              }}
              bold={true}
              style={[
                styles.footText,
                { alignSelf: "flex-start", fontSize: 13 },
              ]}
            >
              Resend via text message
            </CustomText>
            <CustomText
              bold={true}
              style={{ fontSize: 13, color: "#999", marginTop: 5 }}
            >
              {`xxx-xxx-${Phone}`}
            </CustomText>
            {emialSentTo === 2 && (
              <CustomText
                bold={true}
                style={{ color: "#0000ff", fontSize: 12 }}
              >
                Sent
              </CustomText>
            )}
          </>
        )}
      </>
    );
  };
  const handleCreateAccessCode = (WebLoginId, reff, logDetails) => {
    //Sending Access code to user for login,forgot password,etc...

    try {
      handleAPI({
        name: "CreateAccessCodeUsingWeblogin",
        params: { Id: WebLoginId, reff: reff },
      }).then((response) => {
        //For showing (Sent) text under the emial & cellphone
        response = JSON.parse(response)["Table"][0]["Column1"].toString();

        response = response.split("|");
        if (response.length > 2) {
          let msg = "";
          if (Number(response[3]) === 0) msg = response[1];
          setAccesscodeWarningMsg(msg);

          logDetails = {
            ...logDetails,
            ...{ AccessCode: response[2], isEnterAccessCode: true },
          };
          logDetails = { ...logDetails, ...logInDetails };

          setLoginDetails(logDetails);
          handleGetNextStepWeb(logDetails);
        }
      });
    } catch (error) {
      log("Error from handleCreateAccessCode ====> ", error);
    }
  };

  const handleLoginWithBioMetric = async () => {
    try {
      const enroll = await LocalAuthentication.isEnrolledAsync(),
        iBiometricWebLoginId = biometricDetails["WebloginId"];
      if (enroll) {
        const biometricAuth = await LocalAuthentication.authenticateAsync({
          promptMessage: `Confirm your ${ios ? "Face" : "Touch"} ID`,
          disableDeviceFallback: true,
          cancelLabel: "Cancel",
        });

        if (biometricAuth.success) {
          console.log("handleLoginWithBioMetric");
          setBiometricDetails((prevBiometricDetails) => {
            return { ...prevBiometricDetails, isLogin: true };
          });
          setHeaderText(
            `~~~Welcome Back ${biometricDetails["UserName"]}\nWe're logging you in...`
          );
          let SessionId = await handleCreateNewSession(iBiometricWebLoginId);
          let { activeLoanCount = 1, activeLoanId = -999 } =
            (await handleGetActiveLoan(SessionId)) || {};

          if (activeLoanCount == 1) {
            setContextDetails((prevContextDetails) => {
              return {
                ...prevContextDetails,
                ...{ loanId: activeLoanId },
              };
            });

            navigate("Home", {
              userName: biometricDetails["UserName"],
              SessionId,
              loanId: activeLoanId,
            });
          } else {
            setContextDetails((prevContextDetails) => {
              return {
                ...prevContextDetails,
                ...{ Path: "DashBoard", SessionId },
              };
            });
            navigate("DashBoard", {
              SessionId,
            });
          }
          handleClearState();
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleAccessCodeLogin = (reff, logDetails, msg) => {
    //Pre- sete of access code sending process
    let WebLoginId = logInDetails["WebLoginId"];
    try {
      logDetails = logDetails || [];
      msg = msg || "";
      if (handleUserNameValidation()) {
        setErrorMessage({
          color: "#999",
          text: "This is not a valid username. Please enter a valid username to use the Forgot Password function.",
          italic: false,
        });
        return false;
      }
      setLoginDetails({ ...logInDetails, ...logDetails });
      //Getting weblogin details is not exist already
      if (WebLoginId == undefined) {
        handleAPI({
          name: "GetUserNameExists",
          params: { userName: credentials["userName"] },
        }).then((response) => {
          response = JSON.parse(response)["Table"][0];
          WebLoginId = response["WebLoginId"];
          logDetails = { ...logDetails, ...response, ...logInDetails };
          logDetails = handleSetAccessCodeHeader(logDetails, msg, reff);
          handleEmailSentTo(reff);
          handleCreateAccessCode(WebLoginId, reff, logDetails);
          return false;
        });
      } else {
        logDetails = { ...logDetails, ...logInDetails };
        logDetails = handleSetAccessCodeHeader(logDetails, msg, reff);
        handleEmailSentTo(reff);
        handleCreateAccessCode(WebLoginId, reff, logDetails);
      }
    } catch (error) {
      log("Error form handleAccessCodeLogin ====> ", error);
    }
  };
  const handleSetAccessCodeHeader = (logDetails, msg, reff) => {
    msg = msg || "";

    if (logDetails["AccountLocked"] === 1) {
      logDetails = { ...logInDetails, isValidateAccesscode: true };
      msg = "This user account is locked. ";
      msg += `We've ${
        reff === 1 ? "Emailed" : "Text"
      } you an access code!\nEnter it below.`;
      setErrorMessage({ text: "" });
    } else if (logDetails["attemptExceed"] === 1) {
      logDetails = { ...logInDetails, isValidateAccesscode: true };
      if (logDetails["MaxPasscodeIncorrectLogin"] === 5) {
        msg = `2nd Notice. ~~~This Login attempt has been blocked. The maximum login attempts have been exceeded.`;
      } else {
        msg = `~~~This Login attempt has been blocked. ~~~The maximum login attempts have been exceeded.`;
      }
      msg += `We've ${
        reff === 1 ? "Emailed" : "Text"
      } you an access code!\nEnter it below.`;
    }

    setCurrentPage("enterAccessCode");
    setHeaderText(
      "~~~" +
        (msg ||
          `We've ${
            reff === 1 ? "Emailed" : "Text"
          } you an access code!\nEnter it below.`)
    );
    return logDetails;
  };
  const handleLogInValidation = () => {
    log("logInDetails", logInDetails);
    setAccesscodeWarningMsg("");
    handleLoginClick();
  };

  const getHeaderText = () => {
    //Showing the header text
    let header = headerText.replaceAll("~~~~~~", "");
    header = header.split("~~~");
    return (
      <>
        <CustomText
          bold={true}
          style={[styles.headText, { color: isTerminated ? "red" : "#999" }]}
        >
          {header[0] !== "" ? (
            <CustomText bold={true} style={[styles.headText, { color: "red" }]}>
              {header[0]}{" "}
            </CustomText>
          ) : (
            <></>
          )}

          {header[1] === "CustomHeader" ? (
            <>
              <CustomText
                bold={true}
                style={[styles.headText, { fontSize: 17 }]}
              >
                Welcome back{" "}
                <CustomText
                  bold={true}
                  style={[styles.headText, { fontSize: 17, color: "black" }]}
                >
                  {header[2]}
                </CustomText>
                . Please select a login option below.
              </CustomText>
            </>
          ) : (
            <CustomText bold={true} style={[styles.headText, { fontSize: 17 }]}>
              {header[1]}
            </CustomText>
          )}
        </CustomText>
      </>
    );
  };
  const validatePassword = (key, text) => {
    setPasswordMisMatch("");
    setNewPassword({ ...newPassword, ...{ [key]: text, key: key } });
  };
  const navigate = (navigateTo, navigateDetails) => {
    let details = { ...navigateDetails, navigation: navigation };
    setContextDetails((prevContextDetails) => {
      return { ...prevContextDetails, ...details };
    });
    if (performAction) {
      performAction(navigateTo, { ...navigateDetails, loginType });
    } else {
      navigation.navigate(navigateTo, navigateDetails); // Sample ===> "signUp",{}
    }
  };
  //--------------------------------------------//
  //---------- handling password setting - validation and messages ----------//
  useEffect(() => {
    let strength = 0,
      key = newPassword["key"],
      text = newPassword[key];
    if (text !== undefined) {
      if (text.length > 6) strength += 1;
      if (text.match(/([A-Z])/) && text.match(/([0-9])/)) strength += 1;
      if (text.match(/([!,%,&,@,#,jQuery,^,*,?,_,~])/)) strength += 1;
      let msg = ``;
      if (strength < 3) {
        msg = `Password does not meet complexity Requirements.`;
      } else {
        msg = `Password Meets Complexity Requirements`;
      }
      if (key === "confirmPassword" && text !== newPassword["password"]) {
        msg = `Password Does Not Match`;
        strength = 0;
      }
      if (
        (newPassword["password"] === "" && key === "password") ||
        (newPassword["confirmPassword"] === "" && key === "confirmPassword")
      ) {
        msg = "";
      } else {
        msg = (
          <View style={{ marginTop: -10, marginBottom: 10 }}>
            <FontAwesome
              name={strength < 3 ? "close" : "check"}
              size={22}
              color={strength < 3 ? "red" : "green"}
            />
            <CustomText
              bold={true}
              style={{
                color: "#999",
                marginTop: -20,
                marginBottom: 20,
                fontSize: 14,
                marginLeft: 30,
              }}
            >
              {msg}
            </CustomText>
          </View>
        );
      }
      if (
        key === "password" &&
        text !== newPassword["confirmPassword"] &&
        newPassword["confirmPassword"]?.length > 0
      ) {
        setNewPasswordMessage((prevNewPasswordMessage) => ({
          ...prevNewPasswordMessage,
          confirmPasswordMsg: (
            <View>
              <FontAwesome name="close" size={22} color="red" />

              <CustomText
                bold={true}
                style={{
                  color: "#999",
                  marginTop: -25,
                  marginBottom: 20,
                  fontSize: 14,
                  marginLeft: 30,
                }}
              >
                Password Does Not Match
              </CustomText>
            </View>
          ),
        }));
      } else if (
        key === "password" &&
        text === newPassword["confirmPassword"] &&
        newPassword["confirmPassword"]?.length > 0
      ) {
        setNewPasswordMessage((prevNewPasswordMessage) => ({
          ...prevNewPasswordMessage,
          confirmPasswordMsg: (
            <View>
              <FontAwesome name="check" size={22} color="green" />

              <CustomText
                bold={true}
                style={{
                  color: "#999",
                  marginTop: -25,
                  marginBottom: 20,
                  fontSize: 14,
                  marginLeft: 30,
                }}
              >
                Password Meets Complexity Requirements
              </CustomText>
            </View>
          ),
        }));
      }

      setNewPasswordMessage((prevNewPasswordMessage) => ({
        ...prevNewPasswordMessage,
        [`${key}Msg`]: msg,
      }));
    }
  }, [newPassword]);
  //--------------------------------------------//

  //---------- Auto redirecting process and getting Visitor id ----------//
  useEffect(() => {
    const backHandler = BackHandler.addEventListener(
      "hardwareBackPress",
      () => {
        return true;
        // setContextDetails((prevContextDetails) => {
        //   return { ...prevContextDetails, Path: "StartScreen" };
        // });
      }
    );
    return () => {
      // handleClearState();
      backHandler.remove();
    };
  }, []);
  useEffect(() => {
    async function prepare() {
      // android && StatusBar.setBackgroundColor("#fff");
      // ios && StatusBar.setBarStyle("#fff");

      try {
        // await SplashScreen.preventAutoHideAsync();
        await new Promise((resolve) => setTimeout(resolve, 20));
      } catch (e) {
        console.error(e);
      } finally {
        setAppIsReady(true);
        let result = await handleGetStoredCredential();
        if (result !== null) {
          let logDetails = { ...result, ...logInDetails };
          setIsRemember(true);
          logDetails = { ...logDetails, ...logInDetails };
          setLoginDetails(logDetails);
          const { UserDisplayName, loginName } = result;
          setHeaderText(
            `~~~Welcome Back ${
              UserDisplayName || loginName || ""
            }\nWe're logging you in...`
          );
        } else {
          setCurrentPage("emailOnly"); //come Here - enterAccessCode -- emailOnly
        }
      }
      //Visitor Id generator
      let visitorIdOld = JSON.parse(
          (await AsyncStorage.getItem("visitorId")) || null
        ),
        visitorId = null;
      if (visitorIdOld) {
        visitorId = visitorIdOld;
      } else {
        // let randomString = require("randomstring");
        // visitorId = randomString.generate(20);
        visitorId = generateFingerprint();
        visitorId = `D-${visitorId.replaceAll("-", "")}`;
        visitorId = JSON.stringify(visitorId);
        await AsyncStorage.setItem("visitorId", visitorId || null);
      }
      // if (typeof visitorId == "string") visitorId = JSON.parse(visitorId);
      setDeviceId(visitorId || "");

      let params = {
        PageTitle: "Login",
        PageURL: "Go Direct",
        device: "mobile",
        IPAddress: visitorId || 0,
        ParentId: 0,
        detailsJson: JSON.stringify([
          {
            Browser: "Go Direct",
            LoanId: 0,
          },
        ]),
      };
      !__DEV__ &&
        handleAPI({
          name: "LogDWVisitorsEvent",
          params,
        }).then((PageLoadId) => {
          handleTrackGA4Events("GoDirectMortgage LogIn", params);
          AsyncStorage.setItem(
            "iPageLoadId",
            JSON.stringify(PageLoadId || null)
          );
        });
    }
    prepare();
    setIsPasswordSecure(true);
  }, []);

  useEffect(() => {
    (async () => {
      // let details = JSON.parse(
      //   (await AsyncStorage.getItem("BioMetricDetails")) || null
      // );
      // if (!details) {
      //   details = JSON.parse(
      //     (await AsyncStorage.getItem("bioMetricLoginDetails")) || null
      //   );
      //   if (details.length) details = details[0];
      // }
      // if (!details) {
      deviceId && handleSettingsDetails(deviceId);
      // } else {
      //   setBiometricDetails(details);
      // }
    })();
  }, [deviceId, props]);

  const handleSettingsDetails = async (BioMetric) => {
    let bioMetricLoginDetails =
      (await AsyncStorage.getItem("bioMetricLoginDetails")) || "[]";
    bioMetricLoginDetails = JSON.parse(bioMetricLoginDetails);

    if (bioMetricLoginDetails.length) {
      setBiometricDetails(bioMetricLoginDetails[0]);
    } else {
      try {
        return await handleAPI({
          name: "GetSettingsForWebLoginAccount",
          params: { WebLoginId: 0, BioMetric },
        })
          .then(function (response) {
            console.log(response);
            response = JSON.parse(response)["Table"];
            if (response.length > 0) response = response[0];
            if (response["BioMetricId"]) setBiometricDetails(response);
            else setBiometricDetails({});
          })
          .catch(function (err) {
            console.error(
              `Error from GetSettingsForWebLoginAccount ====>  ${err}`
            );
          });
      } catch (error) {}
    }
  };
  const handleSaveSettingsDetails = async (flag) => {
    handleAPI({
      name: "SaveFaceIdToWebLoginAccount",
      params: { WebLoginId: logInDetails["WebLoginId"], BioMetric: deviceId },
    })
      .then(function (response) {})
      .catch(function (err) {
        console.log(`Error from SaveFaceIdToWebLoginAccount ====>  ${err}`);
      });
  };
  const handleLocalAuthentication = async () => {
    try {
      setProcessingStatus("biometricAuth");
      const enroll = await LocalAuthentication.isEnrolledAsync();
      if (enroll) {
        try {
          const biometricAuth = await LocalAuthentication.authenticateAsync({
            promptMessage: `Confirm your ${ios ? "Face" : "Touch"} ID`,
            disableDeviceFallback: true,
            cancelLabel: "Cancel",
          });
          setProcessingStatus(null);
          if (biometricAuth.success) {
            handleSaveSettingsDetails();
            if (
              logInDetails["CellPhone"] === undefined ||
              logInDetails["CellPhone"] === null ||
              logInDetails["CellPhone"] === ""
            ) {
              setCurrentPage("addCellPhone");
              setHeaderText(
                "~~~Optional. Add a Cell Phone Number to your account."
              );
            } else {
              handleLogin(-1, logInDetails);
            }
          } else {
            setProcessingStatus(null);
            handleLogin(-1, logInDetails);
          }
        } catch (error) {
          setProcessingStatus(null);
          console.log(error);
        }
      } else {
        Alert.alert(
          "Enable Biometrics",
          "Please enable biometrics on your device for a secure login experience.",
          [
            {
              text: "Ok",
              onPress: () => {
                if (ios) {
                  Linking.openURL("app-settings:");
                } else if (android) {
                  Linking.openSettings();
                }
                setProcessingStatus(null);
              },
            },
            {
              text: "Cancel",
              onPress: () => {
                setProcessingStatus(null);
              },
            },
          ]
        );
      }
    } catch (error) {
      Alert.alert("Error form handleLocalAuthentication", error.message);
    }
  };
  //--------------------------------------------//

  //---------- Creating new session when auto redirecting process  ----------//
  useEffect(() => {
    if (
      logInDetails["AutoRedirect"] &&
      logInDetails["AutoRedirectCheck"] === undefined
    ) {
      handleCreateSessionWebLogin(logInDetails);
    }
  }, [isRemember, logInDetails]);

  //--------------------------------------------//
  const handleSetBioMetric = async () => {};
  const isFaceIdAvailable = async () => {
    const hardwareSupport = await LocalAuthentication.hasHardwareAsync(),
      available = await LocalAuthentication.supportedAuthenticationTypesAsync();

    return (
      hardwareSupport &&
      available.includes(
        LocalAuthentication.AuthenticationType[
          ios ? "FACIAL_RECOGNITION" : "FINGERPRINT"
        ]
      )
    );
  };
  //---------- Showing splish screen when app loading ----------//
  const onLayoutRootView = useCallback(async () => {
    try {
      if (appIsReady) await SplashScreen.hideAsync();
    } catch (error) {}
  }, [appIsReady]);
  if (!appIsReady) return <></>;
  //--------------------------------------------//

  return (
    <>
      {webPageURL ? (
        <>
          <WebPageView url={webPageURL} />
        </>
      ) : (
        <>
          <View style={{ backgroundColor: "#fff", flex: 1 }}>
            <View
              onLayout={onLayoutRootView}
              style={[
                {
                  maxWidth: 600,
                },
              ]}
            >
              {from != "startScreen" && <DMCImage />}
              <ScrollContainer>
                <View
                  style={[
                    styles.container,
                    {
                      marginBottom: keyboardHeight,
                    },
                  ]}
                >
                  <View style={styles.headContainer}>{getHeaderText()}</View>
                  {!isTerminated && (
                    <View style={styles.bodyContainer}>
                      {currentPage === "emailOnly" ||
                      currentPage === "loginOption" ||
                      currentPage === "enterPassword" ? (
                        <>
                          {!logInDetails["AutoRedirect"] && (
                            <View
                              style={{
                                flexDirection: "row",
                                margin: 10,
                                justifyContent: "space-between",
                                display:
                                  currentPage === "loginOption" ||
                                  currentPage === "enterPassword"
                                    ? "none"
                                    : "flex",
                              }}
                            >
                              <View
                                style={{
                                  width: `${
                                    currentPage === "emailOnly" ? "80%" : "100%"
                                  }`,
                                }}
                              >
                                <InputBox
                                  label="Cell Phone or Email"
                                  autoFocus
                                  type="default"
                                  placeholder="Cell Phone or Email"
                                  onBlur={() => {
                                    if (credentials["userName"] !== "") {
                                      handleNextClick();
                                    }
                                  }}
                                  onChangeText={(text) => {
                                    if (Number(text)) setComplianceMsg(true);
                                    else setComplianceMsg(false);
                                    try {
                                      if (
                                        text === "" &&
                                        currentPage !== "emailOnly"
                                      ) {
                                        setCurrentPage("emailOnly");
                                        setLoginDetails({});
                                      }
                                      updateCredential({
                                        name: "userName",
                                        value: text,
                                      });
                                      setErrorMessage({ text: "" });
                                    } catch (e) {
                                      log("Email or Cell Phone ====> ", e);
                                    }
                                  }}
                                  value={credentials["formatedUserName"]}
                                  validate={
                                    headerText.indexOf(
                                      `Let's create an account`
                                    ) !== -1 && credentials["userName"] === ""
                                  }
                                />

                                {(!web &&
                                  biometricDetails?.WebloginId &&
                                  !logInDetails["WebLoginId"]) ||
                                (!web &&
                                  biometricDetails?.WebloginId &&
                                  logInDetails["WebLoginId"] &&
                                  biometricDetails?.WebloginId ==
                                    logInDetails["WebLoginId"]) ? (
                                  <>
                                    <CustomText
                                      style={{
                                        position: "absolute",
                                        right: 15,
                                        top: 15,
                                      }}
                                      onPress={() => {
                                        if (!biometricDetails["isLogin"])
                                          handleLoginWithBioMetric();
                                      }}
                                    >
                                      {biometricDetails["isLogin"] ? (
                                        <View
                                          style={{
                                            width: 25,
                                            height: 25,
                                          }}
                                        >
                                          <ArrowSpinner
                                            isSpinner={true}
                                            size={18}
                                            duration={1200}
                                          />
                                        </View>
                                      ) : android ? (
                                        <MaterialIcons
                                          name="fingerprint"
                                          color="gray"
                                          size={25}
                                        />
                                      ) : (
                                        <View>
                                          <Image
                                            resizeMode="stretch"
                                            style={{
                                              width: 25,
                                              height: 25,
                                            }}
                                            source={require("../../assets/FaceId_Gray.png")}
                                          />
                                        </View>
                                      )}
                                    </CustomText>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </View>
                              {currentPage === "emailOnly" && (
                                <>
                                  <IconButton
                                    onPress={() => handleNextClick(true)}
                                    title="Next"
                                    style={{ marginLeft: 3 }}
                                    loading={processingStatus === "Next"}
                                    sStyle={{
                                      minWidth: 30,
                                      height: 15,
                                      top: 8,
                                    }}
                                  />
                                </>
                              )}
                            </View>
                          )}
                        </>
                      ) : null}
                      {currentPage === "enterPassword" && (
                        <View
                          style={{ marginHorizontal: 10, marginBottom: -5 }}
                        >
                          <View>
                            <InputBox
                              label="Password"
                              autoFocus
                              secureTextEntry={isPasswordSecure}
                              placeholder="Password"
                              onChangeText={(text) => {
                                setErrorMessage({ text: "" });
                                updateCredential({
                                  name: "password",
                                  value: text,
                                });
                              }}
                              // onBlur={handleLogInValidation}
                              value={credentials["password"]}
                            />

                            <CustomText
                              style={{
                                position: "absolute",
                                right: 20,
                                top: 15,
                              }}
                              onPress={() => {
                                setIsPasswordSecure(!isPasswordSecure);
                              }}
                            >
                              {isPasswordSecure ? (
                                <FontAwesome
                                  name="eye"
                                  color="gray"
                                  size={25}
                                />
                              ) : (
                                <FontAwesome
                                  name="eye-slash"
                                  color="gray"
                                  size={25}
                                />
                              )}
                            </CustomText>
                          </View>
                        </View>
                      )}
                      {currentPage === "enterAccessCode" && (
                        <View
                          style={{ marginHorizontal: 10, marginBottom: -5 }}
                        >
                          <InputBox
                            label="Access Code"
                            autoFocus
                            keyboardType="numeric"
                            placeholder="Please enter your access code..."
                            onChangeText={(text) => {
                              updateCredential({
                                name: "AccessCode",
                                value: text,
                              });
                              setErrorMessage({ text: "" });
                            }}
                            value={credentials["AccessCode"]}
                            // onBlur={handleLogInValidation}
                          />
                        </View>
                      )}
                      {currentPage === "loginOption" && (
                        <View
                          style={{
                            paddingBottom: 15,
                            paddingHorizontal: 5,
                            flexDirection: "row",
                            justifyContent: "space-around",
                            alignItems: "center",
                            //marginTop: -20,
                          }}
                        >
                          <IconButton
                            onPress={(e) => {
                              if (
                                parseInt(logInDetails["AccountTerminated"]) ===
                                1
                              ) {
                                setHeaderText(
                                  "~~~This account is terminated. Contact your administrator or MakeMeAware@directcorp.com for assistance."
                                );
                                handleLogFailedLoginEvent(
                                  "This account is terminated."
                                );
                                setIsTerminated(true);
                                return false;
                              }
                              setCurrentPage("enterPassword");
                              setHeaderText(
                                "~~~Please enter your password below."
                              );
                            }}
                            title="Enter Password"
                          />
                          {/* <CustomText
                            style={{
                              color: "#999",
                              fontSize: 15,
                              verticalAlign: "middle",
                            }}
                          >
                            or
                          </CustomText> */}
                          <IconButton
                            onPress={(e) => {
                              log("send me a code ====> ", logInDetails);
                              if (
                                parseInt(logInDetails["AccountTerminated"]) ===
                                1
                              ) {
                                setHeaderText(
                                  "~~~This account is terminated. Contact your administrator or MakeMeAware@directcorp.com for assistance."
                                );
                                handleLogFailedLoginEvent(
                                  "This account is terminated."
                                );
                                setIsTerminated(true);
                                return false;
                              }
                              if (credentials["userName"].indexOf("@") !== -1)
                                handleAccessCodeLogin(1);
                              else handleAccessCodeLogin(2);
                            }}
                            title="Send me a code"
                          />
                        </View>
                      )}

                      {/* {currentPage === "enterAccessCode" ||
                      currentPage === "enterPassword" ? (
                        <>
                          <IconButton
                            onPress={handleLogInValidation}
                            title={
                              logInDetails["isValidateAccesscode"] ||
                              logInDetails["isForgotPassword"]
                                ? "Validate Access Code"
                                : "Login"
                            }
                            style={{
                              marginHorizontal: 10,
                              marginTop: -15,
                              marginBottom: 10,
                            }}
                          />
                        </>
                      ) : null} */}
                      {currentPage === "addCellPhone" && (
                        <View style={{ margin: 10 }}>
                          <InputBox
                            label="Cell Phone Number"
                            autoFocus
                            keyboardType="numeric"
                            placeholder="Cell Phone Number"
                            onBlur={() => {
                              let text = logInDetails["CellPhone"] || "";
                              text = text
                                .replaceAll("-", "")
                                .replaceAll("(", "")
                                .replaceAll(")", "")
                                .replaceAll(" ", "");
                              //console.log(13);
                              setLoginDetails({
                                ...logInDetails,
                                ...{
                                  CellPhone: text,
                                  formatedCellPhone: FormatPhoneLogin(text),
                                },
                              });
                            }}
                            onChangeText={(text) => {
                              try {
                                text = text
                                  .replaceAll("-", "")
                                  .replaceAll("(", "")
                                  .replaceAll(")", "")
                                  .replaceAll(" ", "");
                                setLoginDetails({
                                  ...logInDetails,
                                  ...{
                                    CellPhone: text,
                                    formatedCellPhone: text,
                                  },
                                });
                              } catch (e) {
                                log("Cell Phone Number ====> ", e);
                              }
                            }}
                            value={logInDetails["formatedCellPhone"]}
                          />
                          <View
                            style={{ flexDirection: "row", display: "flex" }}
                          >
                            <IconButton
                              loading={processingStatus === "addCellPhone"}
                              sStyle={{
                                minWidth: 30,
                                height: 15,
                                top: 8,
                              }}
                              onPress={(e) => {
                                if (logInDetails["CellPhone"] === "") {
                                  setErrorMessage({
                                    text: "Enter a Cell Phone Number.",
                                    color: "#999",
                                    italic: false,
                                  });
                                  return false;
                                }
                                setProcessingStatus("addCellPhone");
                                setErrorMessage({});
                                setHideSecureEmail(true);
                                setCurrentPage("enterAccessCode");
                                setCredentials({
                                  ...credentials,
                                  AccessCode: "",
                                });
                                handleAPI({
                                  name: "SendTextToMobile",
                                  params: {
                                    WebLoginId: logInDetails["WebLoginId"],
                                    Phone: logInDetails["CellPhone"],
                                  },
                                }).then((response) => {
                                  try {
                                    let sList = response.split("|");
                                    if (sList.length > 2) {
                                      if (sList[3] == "0")
                                        setErrorMessage({
                                          text: sList[1],
                                          color: "#999",
                                          italic: false,
                                        });

                                      if (sList[3] == "1") {
                                        let logDe = {
                                          ...logInDetails,
                                          AccessCode: sList[2],
                                        };
                                        setProcessingStatus(null);
                                        setLoginDetails(logDe);
                                        return false;
                                      }
                                    }
                                  } catch (e) {}
                                });
                                return false;
                              }}
                              title="Save"
                              style={{
                                marginBottom: 10,
                              }}
                            />
                            <IconButton
                              onPress={async () => {
                                handleLogin(-1, logInDetails);
                              }}
                              title="Skip"
                              style={{
                                marginBottom: 10,
                                marginLeft: 10,
                              }}
                            />
                          </View>
                        </View>
                      )}
                      {currentPage === "bioMetricOption" && (
                        <View
                          style={{
                            margin: 10,
                            flexDirection: "row",
                            display: "flex",
                            justifyContent: "space-evenly",
                          }}
                        >
                          <IconButton
                            loading={processingStatus === "biometricAuth"}
                            sStyle={{
                              minWidth: 30,
                              height: 15,
                              top: 8,
                            }}
                            onPress={handleLocalAuthentication}
                            title="Enable"
                            style={{
                              marginBottom: 5,
                            }}
                          />
                          <IconButton
                            onPress={() => {
                              if (
                                logInDetails["CellPhone"] === undefined ||
                                logInDetails["CellPhone"] === null ||
                                logInDetails["CellPhone"] === ""
                              ) {
                                setCurrentPage("addCellPhone");
                                setHeaderText(
                                  "~~~Optional. Add a Cell Phone Number to your account."
                                );
                              } else {
                                handleLogin(-1, logInDetails);
                              }
                            }}
                            title="Skip"
                            style={{
                              marginBottom: 10,
                            }}
                          />
                        </View>
                      )}
                      {errorMessage["text"] !== "" && (
                        <CustomText
                          bold={true}
                          italic={
                            errorMessage["italic"] === undefined ? true : false
                          }
                          style={[
                            styles.errorMessage,
                            {
                              color: errorMessage["color"] || "red",
                              marginTop: -5,
                              marginBottom: 0,
                            },
                          ]}
                        >
                          {errorMessage["text"]}
                        </CustomText>
                      )}
                      {complianceMsg && (
                        <>
                          <CustomText
                            bold={false}
                            italic={true}
                            style={[
                              styles.cssCompMsg,
                              {
                                //color: errorMessage["color"] || "red",
                                marginTop: -5,
                              },
                            ]}
                          >
                            {CompMsg}
                          </CustomText>
                          <View
                            style={{
                              display: "flex",
                              marginBottom: 5,
                              marginLeft: 15,
                              textDecorationLine: "none",
                              flexDirection: "row",
                            }}
                          >
                            <CustomText
                              onPress={() => handleOpenPage(1)}
                              bold={false}
                              style={[
                                styles.footTextNoUnderline,
                                {
                                  color: "blue",
                                },
                              ]}
                            >
                              Terms and conditions
                            </CustomText>
                            <CustomText
                              onPress={() => handleOpenPage(2)}
                              bold={false}
                              style={[
                                styles.footTextNoUnderline,
                                {
                                  color: "blue",
                                  marginLeft: 15,
                                },
                              ]}
                            >
                              Privacy Policy
                            </CustomText>
                          </View>
                        </>
                      )}
                      {currentPage === "enterPassword" ||
                      currentPage === "enterAccessCode" ? (
                        <>
                          <View
                            style={{
                              justifyContent: "space-between",
                              flex: 3,
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <View
                              style={{
                                flex:
                                  logInDetails["isValidateAccesscode"] ||
                                  logInDetails["isForgotPassword"]
                                    ? 1.7
                                    : 2,
                                flexDirection: "row",
                                marginLeft: 10,
                                alignItems: "center",
                              }}
                            >
                              <Checkbox
                                value={isRemember}
                                onValueChange={() => {
                                  setIsRemember(!isRemember);
                                }}
                                color={isRemember ? "#0075ff" : undefined}
                              />
                              <View style={{ flexDirection: "column" }}>
                                <CustomText
                                  bold={true}
                                  style={{
                                    color: "#999",
                                    fontSize: 13,
                                    marginLeft: 5,
                                  }}
                                  onPress={() => {
                                    setIsRemember(!isRemember);
                                  }}
                                >
                                  Remember me on this device
                                </CustomText>
                              </View>
                            </View>
                            <View
                              style={{
                                flex:
                                  logInDetails["isValidateAccesscode"] ||
                                  logInDetails["isForgotPassword"]
                                    ? 1.3
                                    : 1,
                              }}
                            >
                              <IconButton
                                onPress={handleLogInValidation}
                                title={
                                  logInDetails["isValidateAccesscode"] ||
                                  logInDetails["isForgotPassword"]
                                    ? "Validate Code"
                                    : "Login"
                                }
                                style={{
                                  marginHorizontal: 10,
                                  marginBottom: 10,
                                  alignSelf: "flex-end",
                                }}
                                loading={processingStatus === "validating"}
                                sStyle={{
                                  minWidth: 35,
                                  height: 18,
                                  top: 8,
                                }}
                              />
                            </View>
                          </View>
                          {(!logInDetails["isForgotPassword"] &&
                            !currentPage === "enterAccessCode") ||
                          currentPage === "enterPassword" ? (
                            <>
                              <View>
                                <View
                                  style={{
                                    borderBottomColor: "black",
                                    borderBottomWidth: 1,
                                    margin: 10,
                                  }}
                                />
                                <View
                                  style={{
                                    marginBottom: 20,
                                    marginHorizontal: 10,
                                  }}
                                >
                                  <CustomText
                                    style={{
                                      fontSize: 17,
                                      color: "#999",
                                      marginBottom: 15,
                                    }}
                                    bold={true}
                                  >
                                    Troubles? No Worries!
                                  </CustomText>
                                  <View
                                    style={{
                                      flexDirection: "row",
                                      flexWrap: "wrap",
                                    }}
                                  >
                                    <CustomText
                                      onPress={() => {
                                        setErrorMessage({ text: "" });
                                        if (
                                          credentials["userName"].indexOf(
                                            "@"
                                          ) !== -1
                                        )
                                          handleAccessCodeLogin(1, {
                                            isForgotPassword: true,
                                          });
                                        else
                                          handleAccessCodeLogin(2, {
                                            isForgotPassword: true,
                                          });
                                      }}
                                      bold={true}
                                      style={[
                                        styles.footText,
                                        { fontSize: 13 },
                                      ]}
                                    >
                                      Forgot Password?
                                    </CustomText>
                                    <CustomText
                                      italic={true}
                                      bold={true}
                                      style={{ color: "#999", fontSize: 12 }}
                                    >
                                      {"  "}
                                      or just{"  "}
                                    </CustomText>
                                    <CustomText
                                      bold={true}
                                      onPress={() => {
                                        try {
                                          if (credentials["userName"] === "") {
                                            setErrorMessage({
                                              text: "Invalid Username",
                                            });
                                            return false;
                                          }
                                        } catch (e) {
                                          log(
                                            "Send me a verification code ===> ",
                                            e
                                          );
                                        }

                                        if (
                                          credentials["userName"].indexOf(
                                            "@"
                                          ) !== -1
                                        )
                                          handleAccessCodeLogin(1);
                                        else handleAccessCodeLogin(2);
                                      }}
                                      style={[
                                        styles.footText,
                                        { fontSize: 13 },
                                      ]}
                                    >
                                      Send me a verification code
                                    </CustomText>
                                  </View>
                                </View>
                              </View>
                            </>
                          ) : null}
                        </>
                      ) : null}
                      {currentPage === "multiLogin" && (
                        <>
                          <View style={styles.imgMultipleLoginWrapper}>
                            <TouchableOpacity
                              activeOpacity={1}
                              onPress={() => {
                                handleCloseOtherSession(logInDetails);
                                handleClearState();
                                handleSetStoredCredential(2);
                              }}
                              style={{ width: "50%" }}
                            >
                              <Image
                                resizeMode="contain"
                                style={styles.imgMultipleLogin}
                                source={require("../../assets/WaitImg.png")}
                              />
                            </TouchableOpacity>
                            <TouchableOpacity
                              activeOpacity={1}
                              style={{
                                width: "50%",
                                alignContent: "center",
                                alignSelf: "center",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                              onPress={() => {
                                setProcessingStatus("proceeding");
                                if (logInDetails["AutoRedirect"])
                                  handleLogin(1, logInDetails);
                                else handleLoginClick(1);
                              }}
                            >
                              <Image
                                resizeMode="contain"
                                style={styles.imgMultipleLogin}
                                source={require("../../assets/ProceedImg.png")}
                              />
                              {["proceeding"].includes(processingStatus) && (
                                <View
                                  style={[
                                    styles.imgMultipleLogin,
                                    {
                                      position: "absolute",
                                      height: 160,
                                      width: "82%",
                                      backgroundColor: "#fff",
                                    },
                                  ]}
                                >
                                  <ArrowSpinner
                                    size={25}
                                    duration={1500}
                                    isSpinner
                                    style={{
                                      flex: 1,
                                    }}
                                  />
                                </View>
                              )}
                            </TouchableOpacity>
                          </View>
                          <View
                            style={{
                              margin: 10,
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <Checkbox
                              value={isRemember}
                              onValueChange={() => {
                                setIsRemember(!isRemember);
                              }}
                              color={isRemember ? "#0075ff" : undefined}
                            />
                            <View style={{ flexDirection: "column" }}>
                              <CustomText
                                bold={true}
                                style={{
                                  color: "#999",
                                  fontSize: 15,
                                  marginLeft: 10,
                                }}
                                onPress={() => {
                                  setIsRemember(!isRemember);
                                }}
                              >
                                Remember me on this device
                                {Platform.OS === "web" && (
                                  <CustomText
                                    style={{ fontSize: 12, color: "#999" }}
                                    bold={true}
                                    italic={true}
                                  >
                                    {"\n"}(not recommended on public computers)
                                  </CustomText>
                                )}
                              </CustomText>
                            </View>
                          </View>
                        </>
                      )}
                      {currentPage === "enterAccessCode" && (
                        <View style={{ margin: 10 }}>
                          <View
                            style={{
                              borderBottomColor: "black",
                              borderBottomWidth: 1,
                              marginTop: 0,
                            }}
                          />
                          <View
                            style={{
                              marginTop: 10,
                              marginBottom: 20,
                            }}
                          >
                            {accesscodeWarningMsg && (
                              <CustomText
                                style={{
                                  fontSize: 16,
                                  color: "#999",
                                  marginBottom: 15,
                                  marginTop: -15,
                                }}
                                bold={true}
                              >
                                {accesscodeWarningMsg}
                              </CustomText>
                            )}
                            <CustomText
                              style={{
                                fontSize: 17,
                                color: "#999",
                                marginBottom: 15,
                              }}
                              bold={true}
                            >
                              Didn't get the code?
                            </CustomText>
                            <View
                              style={{
                                flexDirection: "row",
                                justifyContent: "space-between",
                              }}
                            >
                              <View>{getSecureEmail()}</View>
                              <View>{getSecurePhone()}</View>
                            </View>
                          </View>
                        </View>
                      )}
                      {currentPage === "setPassword&Login" && (
                        <>
                          <View style={{ margin: 20, marginBottom: 30 }}>
                            <CustomText
                              bold={true}
                              style={{
                                fontSize: 18,
                                color: "#999",
                                marginBottom: 5,
                              }}
                            >
                              Set a password or skip and login.
                            </CustomText>
                          </View>
                          <View
                            style={{
                              margin: 20,
                              marginBottom: 30,
                              flexDirection: "row",
                              justifyContent: "space-evenly",
                            }}
                          >
                            <IconButton
                              loading={processingStatus === "loginNow"}
                              sStyle={{
                                minWidth: 30,
                                height: 15,
                                top: 8,
                              }}
                              onPress={() => {
                                setProcessingStatus("loginNow");
                                handleLogin(undefined, logInDetails);
                              }}
                              title="Login Now"
                            />
                            <IconButton
                              disable={processingStatus === "loginNow"}
                              onPress={() => {
                                setCurrentPage("newPassword");
                                setNewPassword({
                                  password: "",
                                  confirmPassword: "",
                                });
                                setNewPasswordMessage({
                                  passwordMsg: "",
                                  confirmPasswordMsg: "",
                                });
                                setNewIsPasswordSecure({
                                  password: true,
                                  confirmPassword: true,
                                });
                              }}
                              icon={false}
                              title="Set Password"
                              buttonType="secondary"
                            />
                          </View>
                        </>
                      )}
                      {currentPage === "newPassword" && (
                        <View style={{ marginHorizontal: 10 }}>
                          <CustomText
                            bold={true}
                            style={{
                              fontSize: 14,
                              color: "#999",
                              marginBottom: 25,
                            }}
                          >
                            {`Please create your password below: 

Password Requirments: 
Minimum length of 6 characters, 1 number, 1 capital letter, and 1 special character such as:
(@!*&).`}
                          </CustomText>
                          <View>
                            <View>
                              <InputBox
                                label="Password"
                                autoFocus
                                type="default"
                                secureTextEntry={
                                  newIsPasswordSecure["password"]
                                }
                                placeholder="Please enter your password..."
                                onChangeText={(text) => {
                                  validatePassword("password", text);
                                }}
                                value={newPassword["password"]}
                                border="#333"
                              />

                              <CustomText
                                style={{
                                  position: "absolute",
                                  right: 20,
                                  top: 15,
                                }}
                                onPress={() => {
                                  setNewIsPasswordSecure({
                                    ...newIsPasswordSecure,
                                    password: !newIsPasswordSecure["password"],
                                  });
                                }}
                              >
                                {newIsPasswordSecure["password"] ? (
                                  <FontAwesome
                                    name="eye"
                                    color="gray"
                                    size={25}
                                  />
                                ) : (
                                  <FontAwesome
                                    name="eye-slash"
                                    color="gray"
                                    size={25}
                                  />
                                )}
                              </CustomText>

                              {newPasswordMessage["passwordMsg"] !== "" &&
                                newPassword["password"] !== "" && (
                                  <>{newPasswordMessage["passwordMsg"]}</>
                                )}
                            </View>
                            <View>
                              <InputBox
                                label="Confirm Password"
                                type="default"
                                secureTextEntry={
                                  newIsPasswordSecure["confirmPassword"]
                                }
                                placeholder="Confirm your password..."
                                onChangeText={(text) => {
                                  validatePassword("confirmPassword", text);
                                }}
                                value={newPassword["confirmPassword"]}
                                border="#333"
                              />
                              <CustomText
                                style={{
                                  position: "absolute",
                                  right: 20,
                                  top: 15,
                                }}
                                onPress={() => {
                                  setNewIsPasswordSecure({
                                    ...newIsPasswordSecure,
                                    confirmPassword:
                                      !newIsPasswordSecure["confirmPassword"],
                                  });
                                }}
                              >
                                {newIsPasswordSecure["confirmPassword"] ? (
                                  <FontAwesome
                                    name="eye"
                                    color="gray"
                                    size={25}
                                  />
                                ) : (
                                  <FontAwesome
                                    name="eye-slash"
                                    color="gray"
                                    size={25}
                                  />
                                )}
                              </CustomText>
                              {newPasswordMessage["confirmPasswordMsg"] !==
                                "" &&
                                newPassword["confirmPassword"] !== "" && (
                                  <>
                                    {newPasswordMessage["confirmPasswordMsg"]}
                                  </>
                                )}
                            </View>
                            <IconButton
                              onPress={() => {
                                if (newPassword["password"] === "") {
                                  setPasswordMisMatch(
                                    "Please enter the New Password."
                                  );
                                  return false;
                                }
                                if (newPassword["confirmPassword"] === "") {
                                  setPasswordMisMatch(
                                    "Please enter the Confirm New Password."
                                  );
                                  return false;
                                }
                                if (
                                  newPassword["confirmPassword"] !==
                                  newPassword["password"]
                                ) {
                                  setPasswordMisMatch(
                                    "The new password and confirmed password do not match."
                                  );
                                  return false;
                                }

                                let strength = 0,
                                  text = newPassword["password"];
                                if (text.length > 6) strength += 1;
                                if (
                                  text.match(/([A-Z])/) &&
                                  text.match(/([0-9])/)
                                )
                                  strength += 1;
                                if (
                                  text.match(/([!,%,&,@,#,jQuery,^,*,?,_,~])/)
                                )
                                  strength += 1;
                                if (strength < 3) {
                                  setPasswordMisMatch(
                                    `Password does not meet minimum complexity requirements, password must contain: 
      Minimum length of 6 characters 
      Must contain 1 number, 1 capital letter, and 1 special character such as: (@!*&)`
                                  );
                                  return false;
                                }
                                strength = 0;
                                text = newPassword["confirmPassword"];
                                if (text.length > 6) strength += 1;
                                if (
                                  text.match(/([A-Z])/) &&
                                  text.match(/([0-9])/)
                                )
                                  strength += 1;
                                if (
                                  text.match(/([!,%,&,@,#,jQuery,^,*,?,_,~])/)
                                )
                                  strength += 1;
                                if (strength < 3) {
                                  setPasswordMisMatch(
                                    `Password does not meet minimum complexity requirements, password must contain: 
      Minimum length of 6 characters 
      Must contain 1 number, 1 capital letter, and 1 special character such as: (@!*&)`
                                  );
                                  return false;
                                }
                                if (
                                  newPassword["password"] ===
                                  newPassword["confirmPassword"]
                                ) {
                                  handleAPI({
                                    name: "SavePasswordRedirect",
                                    params: {
                                      WebLoginId: logInDetails["WebLoginId"],
                                      Password: newPassword["password"],
                                    },
                                  }).then((response) => {
                                    response =
                                      JSON.parse(response)["Table"][0][
                                        "Column1"
                                      ].toString();
                                    response = new XMLParser().parseFromString(
                                      response
                                    )["children"][0]["attributes"];
                                    let msg = response["Message"];
                                    setErrorMessage({ text: "" });
                                    if (
                                      msg === "Password updated successfully."
                                    ) {
                                      handleLogin(1, logInDetails);
                                      setProcessingStatus("Save&Login");
                                    } else setPasswordMisMatch(msg);
                                  });
                                }
                              }}
                              title="Save & Login"
                              loading={processingStatus == "Save&Login"}
                              sStyle={{
                                minWidth: 30,
                                height: 15,
                                top: 8,
                              }}
                              style={{
                                marginBottom: 10,
                                color: "#fff",
                                backgroundColor: "#4C85BF",
                              }}
                            />
                            {passwordMisMatch !== "" && (
                              <View
                                style={{
                                  borderWidth: 1,
                                  borderColor: "#ebccd1",
                                  backgroundColor: "#f2dede",
                                  borderRadius: 5,
                                  marginBottom: 10,
                                }}
                              >
                                <CustomText
                                  style={{
                                    color: "#999",
                                    fontSize: 15,
                                    padding: 15,
                                  }}
                                  bold={true}
                                >
                                  {passwordMisMatch}
                                </CustomText>
                              </View>
                            )}
                          </View>
                        </View>
                      )}
                    </View>
                  )}
                  <View style={styles.footContainer}>
                    {currentPage === "emailOnly" ? (
                      <CustomText
                        onPress={handleCreateNewAccClick}
                        bold={true}
                        style={styles.footText}
                      >
                        Create New Account
                      </CustomText>
                    ) : (
                      <CustomText
                        onPress={(e) => {
                          handleClearState();
                        }}
                        bold={true}
                        style={[
                          styles.footText,
                          {
                            borderBottomWidth: 0,
                            textDecorationLine: "none",
                          },
                        ]}
                      >
                        <AntDesign name="arrowleft" size={15} color="#999" />
                        Back
                      </CustomText>
                    )}
                    {!isTerminated &&
                      (currentPage === "emailOnly" ||
                        currentPage === "loginOption") && (
                        <CustomText
                          onPress={() => {
                            setErrorMessage({ text: "" });
                            if (credentials["userName"].indexOf("@") !== -1)
                              handleAccessCodeLogin(1, {
                                isForgotPassword: true,
                              });
                            else
                              handleAccessCodeLogin(2, {
                                isForgotPassword: true,
                              });
                          }}
                          style={styles.footText}
                          bold={true}
                        >
                          Forgot Password
                        </CustomText>
                      )}
                  </View>
                </View>
              </ScrollContainer>
            </View>
          </View>
        </>
      )}
    </>
  );
}
//Style Section
const styles = StyleSheet.create({
  container: {
    color: "#333",
    backgroundColor: "#f5f5f5",
    borderWidth: 1,
    borderColor: "#ddd",
    borderRadius: 5,
    margin: 5,
    // marginBottom: 300,
  },
  headContainer: {
    marginTop: 5,
    marginBottom: 10,
    padding: 10,
  },
  headText: {
    fontSize: 19,
    color: "#999",
  },
  footContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 10,
    marginTop: 0,
  },
  footText: {
    fontSize: 12,
    color: "#999",
    textDecorationLine: Platform.OS === "android" ? "none" : "underline",
    borderBottomWidth: Platform.OS === "android" ? 1 : 0,
    borderBottomColor: "#999",
  },
  bodyContainer: {
    display: "flex",
    backgroundColor: "#fff",
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderColor: "#ddd",
    paddingTop: 25,
    paddingBottom: 20,
    // paddingHorizontal: 10,
  },
  errorMessage: {
    color: "red",
    fontSize: 15,
    padding: 10,
  },
  imgMultipleLogin: {
    width: "94%",
    height: 200,
  },
  imgMultipleLoginWrapper: {
    flexDirection: "row",
    marginBottom: 30,
    justifyContent: "space-between",
  },
  cssCompMsg: {
    fontSize: 11,
    color: "#999",
    textDecorationLine: "none",
    borderBottomWidth: 0,
    borderBottomColor: "#999",
    padding: 10,
  },
  footTextNoUnderline: {
    fontSize: 12,
    color: "#999",
    textDecorationLine: "none",
    borderBottomWidth: 0,
    borderBottomColor: "#999",
  },
});
